import { render, staticRenderFns } from "./mainIndex.vue?vue&type=template&id=b9af9596"
import script from "./mainIndex.vue?vue&type=script&lang=js"
export * from "./mainIndex.vue?vue&type=script&lang=js"
import style0 from "./mainIndex.vue?vue&type=style&index=0&id=b9af9596&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports